import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';

var _BADGE_ICONS;
var BADGE_VARIANTS = {
  DATA_VIS_1: 'data-vis-1',
  DATA_VIS_2: 'data-vis-2',
  DATA_VIS_3: 'data-vis-3',
  DATA_VIS_4: 'data-vis-4',
  DATA_VIS_5: 'data-vis-5',
  DATA_VIS_6: 'data-vis-6',
  DATA_VIS_7: 'data-vis-7',
  DATA_VIS_8: 'data-vis-8',
  ERROR: 'error',
  INFO: 'info',
  SUBTLE: 'subtle',
  SUCCESS: 'success',
  UNKNOWN: 'unknown',
  WARNING: 'warning'
};
var BADGE_ICONS = (_BADGE_ICONS = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_BADGE_ICONS, BADGE_VARIANTS.ERROR, 'CloseSolid'), BADGE_VARIANTS.INFO, 'Info'), BADGE_VARIANTS.SUBTLE, 'InProgress'), BADGE_VARIANTS.SUCCESS, 'Success'), BADGE_VARIANTS.UNKNOWN, 'InProgress'), BADGE_VARIANTS.WARNING, 'Warning'), BADGE_VARIANTS.DATA_VIS_1, 'InProgress'), BADGE_VARIANTS.DATA_VIS_2, 'InProgress'), BADGE_VARIANTS.DATA_VIS_3, 'InProgress'), BADGE_VARIANTS.DATA_VIS_4, 'InProgress'), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_BADGE_ICONS, BADGE_VARIANTS.DATA_VIS_5, 'InProgress'), BADGE_VARIANTS.DATA_VIS_6, 'InProgress'), BADGE_VARIANTS.DATA_VIS_7, 'InProgress'), BADGE_VARIANTS.DATA_VIS_8, 'InProgress'));

export { BADGE_ICONS, BADGE_VARIANTS };
//# sourceMappingURL=Badge.constants.js.map
